import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Header from './components/Header';
import ProjectsList from './components/ProjectsList';
import ProjectPage from './pages/ProjectPage';
import Footer from './components/Footer';
import projectsData from './data/projectsData';
import AboutPage from './pages/AboutPage';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="container">
        <Router>
          <AppContent />
        </Router>
      </div>
    </ThemeProvider>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  const initializeAnalytics = () => {
    ReactGA.initialize('G-FQFLKW5VQ5');
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  };

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });

    const handleRouteChange = () => { window.scrollTo(0, 0); };

    const checkRedirect = () => {
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect');
      if (redirect) navigate(redirect);
    };

    const updateTitle = () => {
      const path = location.pathname;
      if (path.startsWith('/works/')) {
        const projectId = path.split('/')[2];
        const project = projectsData.find(p => p.id === projectId);
        if (project) {
          document.title = `Evyatar Cohen / ${project.title}`;
        }
      } else if (path === '/about') {
        document.title = 'Evyatar Cohen - About';
      } else {
        document.title = 'Evyatar Cohen';
      }
    };

    window.addEventListener('popstate', handleRouteChange);
    checkRedirect();
    updateTitle();

    return () => { window.removeEventListener('popstate', handleRouteChange); };
  }, [navigate, location]);

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<ProjectsList />} />
        <Route path="works/:projectId" element={<ProjectPage />} /> 
        <Route path="about" element={<AboutPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
